module.exports = __webpack_public_path__ + "static/media/squash.d45be744.svg";